module.exports = __webpack_public_path__ + "img/mortar_pin_blue.2c2247e7.svg";